export function timeFormatter(cell: number, row: number) {

  let dateObject: Date = new Date(cell);

  return formatTime(dateObject.getHours(), dateObject.getMinutes());
}

export function formatTime(hour: number, minute: number) {

  let amPM: string = (hour > 11) ? 'pm' : 'am', result: string = '';
  let flagMinute: boolean = false;

  if (hour > 12) {
    hour -= 12;
  }

  if (minute < 10) {
    flagMinute = true;
  }

  if (hour === 0) {
    result = '12';
  } else {
    result = String(hour);
  }

  result += ':';
  if (flagMinute) {
    result += '0' + String(minute);
  } else {
    result += String(minute);
  }
  result += ' ' + amPM;

  return result;
}



// WEBPACK FOOTER //
// ./src/util/time-util.tsx